<!-- 章节练习 -->
<template>
    <div>
      <div class="course_Practice">
        <el-row class="mb10">
          <label>章节练习汇总：</label>
          【
            合计练习题目数量：<span style="color: #409EFF;margin-right: 20px;">{{analysisInfo.questionTotalCount || 0 | toDecimalx(0)}}</span>
            合计平均答对数量：<span style="color: #409EFF;margin-right: 20px;">{{analysisInfo.avgCorrectCount || 0 | toDecimalx(0)}}</span>
            合计平均答错数量：<span style="color: #409EFF;margin-right: 20px;">{{analysisInfo.avgWrongCount || 0 | toDecimalx(0)}}</span>
            合计平均得分：<span style="color: #409EFF;">{{analysisInfo.avgStudentScore || 0 | toDecimalx(0)}}</span>
          】
        </el-row>
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column type="index" header-align="center" align="center" width="80" label="序号"></el-table-column>
          <el-table-column prop="teacherOpenCourseQuestionSettingName" header-align="center" align="center" label="章节名称"> </el-table-column>
          <el-table-column prop="questionCount" header-align="center" align="center" label="章节练习题目数量"  width="140"> </el-table-column>
          <el-table-column prop="avgSuccessCount" header-align="center" align="center" label="平均答对数量" width="120"> </el-table-column>
          <el-table-column prop="avgErrorCount" header-align="center" align="center" label="平均答错数量" width="120"> </el-table-column>
          <el-table-column prop="avgSuccessRate" header-align="center" align="center" label="平均正确率"  width="120">
            <template slot-scope="scope">
              <template v-if="scope.row.avgSuccessCount > 0 || scope.row.avgErrorCount > 0">
                {{scope.row.avgSuccessRate || 0}} %
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="avgScore" header-align="center" align="center" label="平均得分"  width="120"> </el-table-column>
          <el-table-column prop="user_" header-align="center" align="center" label="操作" width="400">
            <template slot-scope="scope">
              <el-link type="primary" :underline="false" class="mr10" @click="exerciseResults(scope.row)">练习成绩</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="exerciseDetails(scope.row)">练习详情</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="questionList(scope.row)">试题管理</el-link>
              <el-link type="primary" :underline="false" class="mr10" @click="knowledgePoints(scope.row)">绑定知识点</el-link>
              <el-link type="primary" :underline="false" @click="lookQuestions(scope.row)">查看题目</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="block" style="text-align: right;bottom: 0;width: 96%;margin: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page"
            :page-sizes="[8, 20, 50, 100]"
            :page-size="limit"
            background
            :hide-on-single-page="true"
            layout="sizes, prev, pager, next,jumper"
            :total="total">
          </el-pagination>
        </div>

        <!-- 绑定知识点 -->
        <el-dialog
          title="绑定知识点"
          :visible.sync="knowledgePointsShow"
          width="800px"
        >
          <span slot="title">
            <i class="el-icon-notebook-2" style="margin-right: 10px;color: #67C23A;"></i>绑定知识点
          </span>
          <label>归属课程：</label>
          <el-select @change="getCourseInfoList" disabled v-model="pointsInfo.teacherOpenCourseId" placeholder="请选择课程">
            <template v-for="(item ,index) in courseList">
              <el-option :label="item.teacherOpenCourseIdText || item.teacherOpenCourseTitle" :value="item.teacherOpenCourseId"></el-option>
            </template>
          </el-select>
          <label class="ml20">归属章节：</label>
          <el-select clearable @change="getPageList" v-model="pointsInfo.chapterId" placeholder="请选择课程">
            <template v-for="(item ,index) in courseInfoList">
              <el-option :label="item.courseInfoName" :value="item.teacherOpenCourseMergeCourseInfoId"></el-option>
            </template>
          </el-select>
          <el-row class="mt20 mb20">
            <el-transfer v-model="value" :props="{key: 'teacherOpenCourseKnowledgePointId',label: 'knowledgePointTitle'}":titles="['未绑定知识点', '已绑定知识点']" :data="data"></el-transfer>
          </el-row>
          <span slot="footer" class="dialog-footer">
            <el-button @click="knowledgePointsShow = false">取 消</el-button>
            <el-button type="primary" @click="submitPoints">确 认</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
</template>
<script>
import {getCourseInfoList, getCourseList} from "@/common/getInfo"; //加载数据
export default {
  name: 'Practice',
  props: {
    courseId: { //课程ID
      type: String,
      required:true
    }
  },
  created() {
    this.getInfo();
    this.analysis();
  },
  data() {
    return {
      tableData:[],

      total: 0,
      limit:8,
      page:1,
      knowledgePointsShow:false,
      pointsInfo:{},
      data: [],
      value: [],
      courseList:[],
      courseInfoList:[],
      analysisInfo:{}
    }
  },methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.getInfo();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.getInfo();
    },
    analysis(){
      this.$post("/api/teacherOpenCourseQuestionSetting/analysisTotal.do",{teacherOpenCourseId:this.courseId,questionSettingType:"CHAPTER_EXERCISE"}).then((ret) =>{
        if(ret.code == 0){
          this.analysisInfo = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getInfo(){ //获取分页数据
      let param = {
        limit:this.limit,
        page:this.page,
        teacherOpenCourseQuestionSettingType:"CHAPTER_EXERCISE",
        teacherOpenCourseId:this.courseId
      }
      this.$post("/api/teacherOpenCourseQuestionSetting/getPageList.do",param).then((ret) =>{
        if(ret.code == 0){
          this.total = Number(ret.count);
          this.tableData = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    exerciseResults(item){ //练习成绩
      this.$router.push({name:'ExerciseResults',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    },
    exerciseDetails(item){ //练习详情
      this.$router.push({name:'ExerciseDetails',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    },
    questionList(item){ //试题管理
      this.$router.push({name:'QuestionList',query:{id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId,mergeCourseInfoId:item.teacherOpenCourseMergeCourseInfoId}});
    },
    knowledgePoints(item){ //绑定知识点
      this.knowledgePointsShow = true;
      this.value = [];
      // this.pointsInfo.chapterId = item.teacherOpenCourseMergeCourseInfoId;
      this.getCourseList();
      this.pointsInfo.bussinessId = item.teacherOpenCourseQuestionSettingId; //业务ID
      this.pointsInfo.chapterId = null;
      this.getSelectedIds(item); //获取已绑定知识点
    },
    submitPoints(){ //提交知识点绑定
      // if(this.$isEmpty(this.pointsInfo.teacherOpenCourseId)){
      //   this.$message({message: '请选择归属课程！',type: 'warning'});
      //   return;
      // }
      // if(this.$isEmpty(this.pointsInfo.chapterId)){
      //   this.$message({message: '请选择归属章节！',type: 'warning'});
      //   return;
      // }
      // if(this.value.length <= 0){
      //   this.$message({message: '请选择需要绑定的知识点！',type: 'warning'});
      //   return;
      // }
      this.pointsInfo.teacherOpenCourseKnowledgePointIdPlural = this.value.join(",");
      this.pointsInfo.bussinessType = 1;//业务类型1章节练习2课程实操
      let param = this.pointsInfo;
      param.teacherOpenCourseId = "";
      param.chapterId = "";
      param.teacherOpenCourseId = this.courseId;
      this.$post("/jlw/teacherOpenCourseKnowledgePointRelation/add.do",param).then((ret) =>{
        if(ret.code == 0){
          this.knowledgePointsShow = false;
          this.$message({type: 'success',message: '绑定成功！'});
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    lookQuestions(item){ //查看试题
      this.$router.push({name:'TExercises',query:{type:3,id:item.teacherOpenCourseQuestionSettingId,courseId:this.courseId}});
    },
    getCourseList(){ //获取课程
      if(this.courseList.length <= 0){
        getCourseList().then((ret) =>{
          if(ret.code == 0){
            this.courseList = ret.data;
            this.pointsInfo.teacherOpenCourseId = this.courseId;
            this.getCourseInfoList();
          }
        });
      }else{
        this.pointsInfo.teacherOpenCourseId = this.courseId;
        this.getCourseInfoList();
      }
    },
    getCourseInfoList(){ //获取章节
      getCourseInfoList({teacherOpenCourseId:this.pointsInfo.teacherOpenCourseId,chapterId:this.pointsInfo.chapterId}).then((ret) =>{
        if(ret.code == 0){
          this.courseInfoList = ret.data;
          this.getPageList();
        }
      });
    },
    getSelectedIds(item){ //获取已绑定知识点
      this.$get("/api/teacherOpenCourseKnowledgePointRelation/getBoundKnowledgeList.do",{teacherOpenCourseId:this.courseId,bussinessId:item.teacherOpenCourseQuestionSettingId,bussinessType:1}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.value = ret.data;
          }else{
            this.value = [];
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getPageList(){ //根据课程ID获取知识点
      let param = {
        teacherOpenCourseId:this.pointsInfo.teacherOpenCourseId,
        chapterId:this.pointsInfo.chapterId
      }
      this.$post("/api/teacherOpenCourseKnowledgePoint/getKnowledgePoint.do",param).then((ret) =>{
        if(ret.code == 0){
          this.data = ret.data;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
  }
};
</script>
<style  lang="less">
  .course_Practice{
    padding: 20px;
    border: 1px solid #DEDEDE;
    .title_practice{
      margin: 0;
      margin-left: 15px;float: left;
      width: calc(100% - 155px);
    }
    .number_practice{
      margin: 0;
      float: right;
      width: 140px;
      text-align: right;
    }
    .grade_Practice{
      display: flex;
      justify-content:center;
      align-items:center;
      width: 80px;height: 80px;margin: 0 auto;
      font-size: 22px;
      color: #F83131;
      background-color: #FFF6F6;
      border-radius: 50%;
      span{
        font-size: 14px;
        margin-left: 2px;
      }
    }
    .practice_img{
      width: 30px;
      height: 30px;
    }
    .el-transfer-panel{
      width: 280px !important;
    }
    @media screen and (max-width:1536px){
      li{
        width: calc(33% - 66px);
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/Teacher/components/Practice.vue